// extracted by mini-css-extract-plugin
module.exports = {"s15gsi4h":"s15gsi4h"};